import { createContext, useContext, useState } from "react";
import {
  FinalFeedbackAnswers,
  FinalFeedbackAnswer,
  FinalFeedbackContextType,
  FormattedFinalFeedbackAnswer,
} from "../types/context";

const FinalFeedbackContext = createContext<
  FinalFeedbackContextType | undefined
>(undefined);

const FinalFeedbackProvider = ({ children }: { children: React.ReactNode }) => {
  const [answers, setAnswers] = useState<FinalFeedbackAnswers>({});

  const updateAnswer = (id: number, answer: FinalFeedbackAnswer) => {
    setAnswers((prev) => ({ ...prev, [id]: answer }));
  };

  const getFormattedAnswers = (): {
    answers: FormattedFinalFeedbackAnswer[];
  } => {
    return {
      answers: Object.entries(answers).map(([id, answer]) => ({
        id: Number(id),
        answer:
          typeof answer === "string"
            ? answer === "بله" || answer === "مناسب بود"
            : typeof answer === "number"
              ? answer
              : false,
      })),
    };
  };

  return (
    <FinalFeedbackContext.Provider
      value={{ answers, updateAnswer, getFormattedAnswers }}
    >
      {children}
    </FinalFeedbackContext.Provider>
  );
};

function useFinalFeedbackContext(): FinalFeedbackContextType {
  const context = useContext(FinalFeedbackContext);
  if (context === undefined)
    throw new Error(
      "FinalFeedbackContext was used outside the FinalFeedbackProvider"
    );
  return context;
}

export { FinalFeedbackProvider, useFinalFeedbackContext };
